import React, { useContext, useEffect, useState } from 'react';
import { RECALLS } from '../../support-constants';
import { useRecallsContent } from '../recalls/hook/use-recalls-content';
import SupportFdsWrapper from '../../components/support-fds-wrapper/support-fds-wrapper';
import { useHistory, useParams } from 'react-router-dom';
import './recalls-details.scss';
import ServerContext from '../../../contexts/serverContext';
import siteMapService from '../../services/site-map-service/site-map-service';
import { useRecallData } from '../../../components/sections/vehicle-portal/hooks/use-recall-data';
import { useAnalytics } from '../../../hooks/use-analytics';
import { useFmaLoginValueContent } from '../../components/FMALogin/hook/use-fma-login';
import { usePreferredDealer } from '../../../components/sections/vehicle-health-report/hooks/use-preferred-dealer';
import useSeoConfig from '../../../hooks/use-seo-config';
import { useVehicleAttributes } from '../../../components/sections/vehicle-portal/hooks/use-vehicle-attributes-data';
import { useVinSelectorContent } from '../../../components/sections/vehicle-selector-fds/vin-selector/hook/use-vin-selector';
import { getVinFromLocalStorageIfExists } from '../../../components/sections/vehicle-selector-fds/vin-selector/vin-selector';
import { useExemptWordsContent } from '../recalls/hook/use-exempt-word-list';
import { getAemVehicleModelData } from '../../../hooks/use-aem-vehicle-model-data';
import { VehicleYmm } from '../../../models/vehicle-ymm';
import isWebviewCheck from '../../../components/utils/webviewCheck/webviewCheck';
import { useNotificationBannerContent } from '../../../components/sections/notification-banner/hooks/use-notification-banner';
import {
    findByAliasForRecalls,
    getRecallsLandingLink,
    isIMGTakataCampaignIdPresent,
    isIMGTakataRoute,
} from './recalls-util';
import printIcon from '../../../assets/print-icon.svg';
import { useSupportCommonContent } from '../../components/astute-topic/hook/use-support-common';
import serverSideService from '../../../services/server-side-service/server-side-service';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';
import { scrollToTop } from '../../../components/sections/vehicle-health/vha-utils';
import { useVehicleSelectorTabsContent } from '../../../components/common/vehicle-selector-tabs/hooks/use-vehicle-selector-tabs-content';
import { RecallsVehicleInformation } from './recalls-vehicle-information';
import { RecallsVinDealerButton } from './recalls-vin-dealer-button';
import { RecallsSupportAccordion } from './recalls-support-accordion';
import { RecallsApiErrorMessage } from './recalls-api-error-message';
import { VehicleSelectorTabsContainer } from './vehicle-selector-tabs-container';
import { RecallsDetailsLoaderAndPageNotFound } from './recalls-details-loader-and-page-not-found';
import { VehicleVinBackButton } from './vehicle-vin-back-button';
import { getParamVin } from './util/recalls-details-param-vin';
import { findByAlias } from '../../../routes';
import { BreadcrumbsAndViewBannerContainer } from './breadcrumbs-and-view-banner-container';
import WebFlashMessage from '../../../components/common/web-flash-message/web-flash-message';
import DisclosuresLinkSyndicationAware from '../../../components/sections/disclosures-link/disclosures-link-syndication-aware';
import ImportantInfoAccordion from '../../../components/sections/important-info-acccordion/important-info-accordion';
import NotificationBanner from '../../../components/sections/notification-banner/notification-banner';
import useFooterDisplay from '../../../hooks/use-footer-display';

export const isItAVin = (input: string) => {
    const vinRegex = /^[A-Za-z0-9]{17}$/;
    if (!vinRegex.test(input)) {
        return false;
    }
    return true;
};
import { useSearchContent } from '../../../components/sections/search-bar/hooks/use-search-content';
import { useHelpCardsContent } from '../../../views/page-not-found-view/hooks/use-help-cards-content';
import {
    displayEUFooter,
    hideEUFooter,
} from '../../../components/utils/syndicate-util/syndicate-util';
import {
    EU_COUNTRIES,
    SYNDICATED_IMG_HEADER_COUNTRIES,
} from '../../../constants';
import DateTimeUtil from '../../../components/utils/date-time-util/date-time-util';
import { format } from 'date-fns';
import { SearchBar } from '../../../components/sections';

function getRecallsPdfTimestampImg() {
    let requiredDate = DateTimeUtil.toLocaleDateString(
        DateTimeUtil.dateWithMonthString,
        new Date()
    );
    requiredDate = requiredDate.replaceAll(' ', '-');
    return requiredDate;
}

const RecallsDetailsPage = () => {
    const serverContext = useContext(ServerContext);
    const { vin, vinOrModel, year } = useParams<{
        vin: string;
        vinOrModel: string;
        year: string;
    }>();

    const isWebview = isWebviewCheck();
    const webviewVin = serverContext.webviewData?.vin;
    const webViewPageType = serverContext.recallsType;
    const showRecalls = webViewPageType !== 'csp';
    const showCsp = webViewPageType !== 'recalls';
    const verifiedYear =
        parseInt(year, 10) > 1900 && parseInt(year, 10) < 2100 ? year : '';
    const paramVin = getParamVin({ vinOrModel, vin, year: verifiedYear });

    const model =
        vinOrModel && !isItAVin(vinOrModel) && verifiedYear ? vinOrModel : '';
    const [loading, setLoading] = useState(true);
    let timeOut: any = null;
    const exemptWordsContent = useExemptWordsContent();
    const startTimeout = () => {
        timeOut = setTimeout(() => {
            if (loading) {
                recallsContent = null;
                setLoading(false);
            }
        }, 2000);
    };
    const fmaLoginValueContent = useFmaLoginValueContent();
    const vinSelectorContent = useVinSelectorContent();
    const supportCommonContent = useSupportCommonContent();
    const history = useHistory();
    const searchContent = useSearchContent();
    const helpCardsContent = useHelpCardsContent();
    const appConfig = new AppConfigurationService();
    const countryCode = appConfig.current3LetterCountryCode;
    const isUsa = countryCode === 'usa';
    const isCanada = countryCode === 'can';
    const [queryVin, setQueryVin] = useState(getVinFromLocalStorageIfExists());
    const vinToSearch: string = paramVin || webviewVin || queryVin;
    const [modalVisible, setModalVisible] = useState(true);
    const [recallErrorMsg, setRecallErrorMsg] = useState('');
    const [invalidVinError, setInvalidVinError] = useState(false);
    const [displayName, setDisplayName] = useState<string>('');
    const [vinPageLoadEventFiredFor, setVinPageLoadEventFiredFor] = useState<
        string
    >('');
    const [
        showTakataAirBagNotification,
        setShowTakataAirBagNotification,
    ] = useState(false);
    const [
        isImgTakataCampaignIdPresent,
        setImgTakataCampaignIdPresent,
    ] = useState(false);
    const baseUrl = siteMapService.getBaseUrl(
        serverContext.currentLanguageRegionCode,
        serverContext.brand
    );
    const isImgTakataRoute = isIMGTakataRoute();
    let recallsContentPath: string[] = [];
    let seoName = 'recalls-details';
    let seoPath = 'recalls';
    const seoShortCodes = [
        {
            fieldName: 'vin',
            fieldValue: vinToSearch,
        },
    ];
    let recallsDetailsShortCodeName = 'recalls-details';
    let recallsDetailsPageLoadEvent = 'owner-recalls-details';
    let recallsResultsCtaClickEvent = 'recalls-results-cta';
    if (isImgTakataRoute) {
        recallsContentPath = ['takata-recalls', 'takata-recalls'];
        seoName = 'takata-recalls-details';
        seoPath = 'takata-recalls';
        recallsDetailsShortCodeName = 'takata-recalls-details';
        recallsDetailsPageLoadEvent = 'owner-takata-recalls-details';
        recallsResultsCtaClickEvent = 'takata-recalls-results-cta';
    }
    let recallsContent = useRecallsContent(...recallsContentPath);
    useSeoConfig(seoName, seoPath, seoShortCodes);
    const isYmm = !vinToSearch;
    const recallsLandingLink = getRecallsLandingLink(
        serverContext.currentLanguageRegionCode,
        serverContext.brand,
        isImgTakataRoute
    );

    serverContext.canonical = baseUrl.domain
        .concat(baseUrl.root)
        .concat(
            siteMapService.getPathFromRouterConfigs(
                serverContext.currentLanguageRegionCode,
                serverContext.brand,
                'RecallsPage',
                [],
                isImgTakataRoute
            ) || ''
        );

    const vehicleAttributes = useVehicleAttributes(vinToSearch);
    const recallApiResponse = useRecallData(vinToSearch, model, verifiedYear);
    const recallData = recallApiResponse?.recallData;
    const loadTime = recallApiResponse?.loadTime;
    const [fireEvents] = useAnalytics();
    const vehicleSelectorTabsLabels = useVehicleSelectorTabsContent();
    const getCurrentDate = () => format(new Date(), 'MM/dd/yyyy');
    const preferredDealer = usePreferredDealer(vinToSearch)
        ?.dealerResultList[0];
    const notificationBannerContent = useNotificationBannerContent(
        'recalls',
        'notification-banner'
    );

    const globalNotificationBannerContent = useNotificationBannerContent(
        '',
        'global-notification-banner'
    );

    const isLincoln = serverContext.brand.toLowerCase() === 'lincoln';
    const isFord = serverContext.brand.toLowerCase() === 'ford';
    const printerPage = () => {
        serverSideService.isClientSide() && window.print();
    };

    useEffect(() => {
        startTimeout();
        return () => {
            clearTimeout(timeOut);
        };
    });

    useEffect(() => {
        if (!queryVin && !paramVin && !verifiedYear && !model && !webviewVin) {
            history.push(recallsLandingLink);
        }
        scrollToTop();
    }, []);
    useEffect(() => {
        if (
            vinPageLoadEventFiredFor !== vehicleAttributes.vin &&
            vehicleAttributes.year > 0
        ) {
            fireEvents(
                [recallsDetailsPageLoadEvent],
                undefined,
                {
                    recallsDetails: recallsDetailsShortCodeName,
                    ymm: vehicleAttributes,
                },
                false
            );
            setVinPageLoadEventFiredFor(vehicleAttributes.vin || '');
        }
    }, [vehicleAttributes, recallsContent, recallData]);

    const showRecallsErrorMessage = () => {
        const validVin = isItAVin(vinToSearch) ? vinToSearch : '';
        if (validVin || (verifiedYear && model)) {
            if (recallData && !recallData.successfulResponse) {
                setRecallErrorMsg(recallsContent?.detailsAPIError || '');
                setInvalidVinError(false);
            } else {
                setRecallErrorMsg('');
            }
        } else {
            setRecallErrorMsg(vinSelectorContent?.invalidVin || '');
            setInvalidVinError(true);
        }
    };

    const TakataAirBagNotification = () => {
        if (recallData?.nhtsa) {
            recallData?.nhtsa.forEach(recall => {
                if (
                    recall?.manufacturerRecallNumber &&
                    RECALLS.TAKATA_CAMPAIGN_IDS.includes(
                        recall.manufacturerRecallNumber.toLowerCase()
                    ) &&
                    !showTakataAirBagNotification
                ) {
                    setShowTakataAirBagNotification(true);
                }
            });
        }
    };

    const IMGTakataAirbagRecall = () => {
        const isIMGTakataCampaignIdPresentValue = recallData?.recalls?.some(
            recall =>
                isIMGTakataCampaignIdPresent(
                    serverContext.currentLanguageRegionCode,
                    recall.fsaNumber
                )
        );
        setImgTakataCampaignIdPresent(!!isIMGTakataCampaignIdPresentValue);
    };

    useEffect(() => {
        showRecallsErrorMessage();
        TakataAirBagNotification();
        IMGTakataAirbagRecall();
        sessionStorage.setItem('selectedVin', vinToSearch);
    }, [recallData, recallsContent]);

    useEffect(() => {
        if (model && verifiedYear) {
            setQueryVin('');
            getAemVehicleModelData(
                serverContext.brand,
                serverContext.currentRegionCode,
                serverContext.currentLanguageRegionCode,
                verifiedYear,
                model,
                'SEO_KEY'
            ).then((data: VehicleYmm | undefined) => {
                if (data !== undefined) {
                    setDisplayName(data.model);
                } else {
                    setDisplayName(model);
                }
            });
            scrollToTop();
        }
    }, [verifiedYear, model]);

    let recallsHref: null;
    if (isFord && (isUsa || isCanada)) {
        recallsHref = findByAlias('TakataRecallsPage');
    } else {
        recallsHref = findByAliasForRecalls('RecallsPage', isImgTakataRoute);
    }
    useEffect(() => {
        if (
            serverContext.brand === 'ford' &&
            EU_COUNTRIES.includes(serverContext.currentRegionCode)
        ) {
            if (recallData?.successfulResponse !== true) {
                hideEUFooter();
            }
        }
    }, []);

    useEffect(() => {
        if (
            serverContext.brand === 'ford' &&
            EU_COUNTRIES.includes(serverContext.currentRegionCode)
        ) {
            recallsContent &&
            recallData &&
            fmaLoginValueContent &&
            helpCardsContent &&
            searchContent
                ? displayEUFooter()
                : hideEUFooter();
        }
    }, [
        recallsContent,
        recallData,
        fmaLoginValueContent,
        helpCardsContent,
        searchContent,
    ]);
    useFooterDisplay(
        serverContext.brand === 'ford'
            ? [recallsContent]
            : [
                  recallsContent,
                  recallData,
                  fmaLoginValueContent,
                  helpCardsContent,
                  searchContent,
              ]
    );

    return (
        <>
            {recallsContent?.hideContent === false &&
            recallsContent.recallsDescription !== 'loading' ? (
                <SupportFdsWrapper>
                    {notificationBannerContent &&
                        notificationBannerContent.bannerText &&
                        showTakataAirBagNotification &&
                        !isWebview && (
                            <NotificationBanner
                                hide={notificationBannerContent?.hide}
                                type={notificationBannerContent?.type}
                                bannerDismissible={
                                    notificationBannerContent?.bannerDismissible
                                }
                                dismissAriaLabel={
                                    notificationBannerContent?.dismissAriaLabel
                                }
                                bannerText={
                                    notificationBannerContent?.bannerText
                                }
                                showChevron={
                                    notificationBannerContent?.showChevron
                                }
                                shortCode={{ ctaType: 'airbag faq' }}
                                eventName={recallsResultsCtaClickEvent}
                                contentId="recalls-details-airbag-notif-banner"
                            />
                        )}
                    <WebFlashMessage
                        experience={'recalls'}
                        fragmentName={'experience-notification-banner'}
                    />
                    {globalNotificationBannerContent &&
                        globalNotificationBannerContent.bannerText && (
                            <NotificationBanner
                                hide={globalNotificationBannerContent?.hide}
                                type={globalNotificationBannerContent?.type}
                                bannerDismissible={
                                    globalNotificationBannerContent?.bannerDismissible
                                }
                                dismissAriaLabel={
                                    globalNotificationBannerContent?.dismissAriaLabel
                                }
                                bannerText={
                                    globalNotificationBannerContent?.bannerText
                                }
                                showChevron={
                                    globalNotificationBannerContent?.showChevron
                                }
                                contentId="recalls-details-global-notif-banner"
                            />
                        )}
                    {!isWebview && (
                        <BreadcrumbsAndViewBannerContainer
                            recallsContent={recallsContent}
                            recallsHref={recallsHref}
                            vinToSearch={vinToSearch}
                            displayName={displayName}
                            year={verifiedYear}
                        />
                    )}

                    {recallsContent && (
                        <div id="recalls-content" className="recalls-content">
                            <div className="recalls-title">
                                {!isWebview && recallsContent && (
                                    <>
                                        <div className="recalls-title-left-items">
                                            <h1>{recallsContent.title}</h1>
                                        </div>

                                        <div className="recalls-title-right-items">
                                            {recallsContent.recallsLastUpdatedText && (
                                                <div className="recalls-last-updated">
                                                    {recallsContent.recallsLastUpdatedText +
                                                        ' ' +
                                                        getCurrentDate()}
                                                </div>
                                            )}
                                            <button
                                                className="print-button"
                                                aria-label={
                                                    supportCommonContent?.printAriaLabel ||
                                                    'click to print article'
                                                }
                                                onClick={() => {
                                                    printerPage();
                                                    fireEvents(
                                                        recallsResultsCtaClickEvent,
                                                        undefined,
                                                        {
                                                            ctaType:
                                                                'print recalls page',
                                                        },
                                                        false
                                                    );
                                                }}
                                                data-testid="recalls-print-button"
                                            >
                                                <img
                                                    src={printIcon}
                                                    alt=""
                                                    className="close-icon"
                                                    loading="lazy"
                                                />
                                            </button>
                                            {SYNDICATED_IMG_HEADER_COUNTRIES.includes(
                                                serverContext.currentRegionCode
                                            ) ? (
                                                <time
                                                    data-testid="recalls-pdf-time-stamp"
                                                    className="recalls-pdf-time-stamp"
                                                    dateTime={getRecallsPdfTimestampImg()}
                                                >
                                                    {getRecallsPdfTimestampImg()}
                                                </time>
                                            ) : null}
                                        </div>
                                    </>
                                )}
                            </div>

                            <RecallsApiErrorMessage
                                invalidVinError={invalidVinError}
                                recallErrorMsg={recallErrorMsg}
                            />
                            <VehicleVinBackButton
                                recallsContent={recallsContent}
                                vinToSearch={vinToSearch}
                                setQueryVin={setQueryVin}
                                fmaLoginValueContent={fmaLoginValueContent}
                                recallsLandingLink={recallsLandingLink}
                                vehicleSelectorTabsLabels={
                                    vehicleSelectorTabsLabels
                                }
                                isWebview={isWebview}
                            />
                            <RecallsVehicleInformation
                                vehicleAttributes={vehicleAttributes}
                                year={verifiedYear}
                                recallsContent={recallsContent}
                                isYmm={isYmm}
                                modalVisible={modalVisible}
                                setModalVisible={setModalVisible}
                                displayName={displayName}
                                vinToSearch={vinToSearch}
                                loadTime={loadTime}
                                isWebview={isWebview}
                                recallErrorMsg={recallErrorMsg}
                                showRecalls={showRecalls}
                                exemptWordsContent={exemptWordsContent}
                                recallData={recallData}
                                isLincoln={isLincoln}
                                model={model}
                                showCsp={showCsp}
                                recallApiResponse={recallApiResponse}
                                appConfig={appConfig}
                                isImgTakataCampaignIdPresent={
                                    isImgTakataCampaignIdPresent
                                }
                                isImgTakataRoute={isImgTakataRoute}
                            />

                            {isWebview ? (
                                <div className="recalls-webview-padding"></div>
                            ) : (
                                <>
                                    <RecallsVinDealerButton
                                        recallsContent={recallsContent}
                                        isYmm={isYmm}
                                        preferredDealer={preferredDealer}
                                        vinToSearch={vinToSearch}
                                    />
                                    <VehicleSelectorTabsContainer
                                        vehicleSelectorTabsLabels={
                                            vehicleSelectorTabsLabels
                                        }
                                        setQueryVin={setQueryVin}
                                        setDisplayName={setDisplayName}
                                    />
                                    <RecallsSupportAccordion
                                        recallsContent={recallsContent}
                                        recallData={recallData}
                                    />
                                    {recallsContent.relatedTopicsContent && (
                                        <>
                                            <h2 className="info-title">
                                                {
                                                    recallsContent.relatedTopicsTitle
                                                }
                                            </h2>
                                            <div
                                                className="recalls-content-3"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        recallsContent.relatedTopicsContent,
                                                }}
                                            />
                                        </>
                                    )}
                                    {serverContext.brand === 'lincoln' &&
                                        serverContext.currentLanguageRegionCode ===
                                            'en-us' &&
                                        searchContent &&
                                        helpCardsContent && (
                                            <SearchBar
                                                searchContent={searchContent}
                                                helpCardsContent={
                                                    helpCardsContent
                                                }
                                            />
                                        )}
                                    <DisclosuresLinkSyndicationAware />
                                    <ImportantInfoAccordion
                                        aemFolder="recalls"
                                        accordionContent={
                                            RECALLS.DISCLAIMERS_ACCORDION_CONTENT
                                        }
                                    />
                                </>
                            )}
                        </div>
                    )}
                </SupportFdsWrapper>
            ) : (
                <RecallsDetailsLoaderAndPageNotFound
                    recallsContent={recallsContent}
                />
            )}
        </>
    );
};

export default RecallsDetailsPage;
